import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from 'react-toastify';
import {
  getTicketTransports,
  createTicketTransport,
  updateTicketTransport,
  deleteTicketTransport,
} from "../../api/TICKET/transport";

/** Fetch transports for a ticket */
export const useTicketTransports = (ticketId) =>
  useQuery({
    queryKey: ["ticketTransports", ticketId],
    queryFn: () => getTicketTransports(ticketId),
    enabled: !!ticketId,
    staleTime: 60 * 1000,
  });

/** Create transport for a ticket */
export const useCreateTransport = (ticketId) => {
  const qc = useQueryClient();

  const mutation = useMutation({
    mutationFn: (payload) => createTicketTransport(ticketId, payload),
    onSuccess: () =>
      qc.invalidateQueries({ queryKey: ["ticketTransports", ticketId] }),
    onError: (error) =>
      toast.error(error.message || 'Erreur lors de la création du transport'),
  });

  return { ...mutation, isPending: mutation.isPending };
};

/** Update transport */
export const useUpdateTransport = (ticketId) => {
  const qc = useQueryClient();

  const mutation = useMutation({
    mutationFn: (payload) => updateTicketTransport(ticketId, payload),
    onSuccess: () =>
      qc.invalidateQueries({ queryKey: ["ticketTransports", ticketId] }),
    onError: (error) =>
      toast.error(error.message || 'Erreur lors de la mise à jour du transport'),
  });

  return { ...mutation, isPending: mutation.isPending };
};

/** Delete transport */
export const useDeleteTransport = (ticketId) => {
  const qc = useQueryClient();

  const mutation = useMutation({
    mutationFn: (transportationId) =>
      deleteTicketTransport(ticketId, transportationId),
    onSuccess: () =>
      qc.invalidateQueries({ queryKey: ["ticketTransports", ticketId] }),
    onError: (error) =>
      toast.error(error.message || 'Erreur lors de la suppression du transport'),
  });

  return { ...mutation, isPending: mutation.isPending };
};